export const headerRow = [
  'SI. No',
  'Name',
  'Email',
  'Batch',
  'Mobile #',
  'Status',
  'Name',
  'State',
  'City',
  'Degree',
  'Department',
  'Current Education',
  '10th',
  '12th',
  'Diploma',
  'UG',
  'PG',
]

export const titleColors = [
  'DEE6EF',
  'FFFFFF',
  'FFFFFF',
  'DEE6EF',
  'FFFFFF',
  '6D9EEB',
  '6D9EEB',
  '6D9EEB',
  '6D9EEB',
  '6D9EEB',
  '6D9EEB',
  '6D9EEB',
]
export const secondTitleColors = [
  'DEE6EF',
  'DEE6EF',
  'DEE6EF',
  'DEE6EF',
  'DEE6EF',
  'DEE6EF',
  'DEE6EF',
  'DEE6EF',
  'DEE6EF',
  'DEE6EF',
  'DEE6EF',
  'DEE6EF',
  'DEE6EF',
  'DEE6EF',
  'DEE6EF',
  'DEE6EF',
  'DEE6EF',
  'DEE6EF',
]
export const Status = status => {
  let tagMessage
  if (status == 'ACTIVE' || status == 'APPLIED') {
    tagMessage = 'Applied'
  } else if (status == 'SHORTLISTED') {
    tagMessage = 'Shortlisted'
  } else if (status == 'REJECTED') {
    tagMessage = 'Rejected'
  } else if (status == 'HOLD') {
    tagMessage = 'Hold'
  } else if (status == 'PENDING') {
    tagMessage = 'Pending'
  } else if (status == 'SELECTED') {
    tagMessage = 'Selected'
  } else {
    tagMessage = 'Applied'
  }

  return tagMessage
}

export function toCamelCase(str) {
  const words = str?.split(' ')
  const camelCaseWords = words?.map(word => {
    return word?.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
  })
  return camelCaseWords ? camelCaseWords?.join(' ') : 'NA'
}
